import { SelectOption } from './timeRanges';

export const filterOptionByLabel = (
  option: SelectOption,
  inputValue: string,
): boolean =>
  (option.label.toString().toLowerCase().match(inputValue.toLowerCase()) || [])
    .length > 0;
